import api from "@/api/settings";
// initial state
const state = {
    setting: {}
};
// getters
const getters = {
    setting: state => {
        return state.setting;
    }
};

// actions
const actions = {
    getSettings: async (context) => {
        const result = (await api.getSettings()).data;
        context.commit("getSettings", result);
    },
    postSetting: async (context, Setting) => {
        const result = (await api.postSetting(Setting)).data;
        context.commit("postSetting", result);
    },
    putSetting: async (context, Setting) => {
        const result = (await api.putSetting(Setting)).data;
        context.commit("putSetting", result);
    }
};

// mutations
const mutations = {
    getSettings(state, settings) {
        state.product = null;
        state.setting = {
            ...state.setting,
            ...settings,
            company: { ...(state.setting.company || {}), ...(settings.company || {}) },
            smtp: { ...(state.setting.smtp || {}), ...(settings.smtp || {}) },
            cargo: { ...(state.setting.cargo || {}), ...(settings.cargo || {}) }
        };
    },
    postSetting(state, settings) {
        state.setting = null;
        state.setting = Object.assign({}, state.setting, settings);
    },
    putSetting(state, settings) {
        state.setting = null;
        state.setting = Object.assign({}, state.setting, settings);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};